

export const apiURL ="https://restcountries.com/v3.1"